import React from "react";
import Spinner from "./Spinner";

const Loading = ({ className }) => {
  return (
    <div
      className={`h-dvh flex items-center justify-center fixed inset-0 z-30 bg-surface-container-transparent  ${className ?? ""}`}
    >
      <Spinner size="lg" />
    </div>
  );
};

export default Loading;
